import { render, staticRenderFns } from "./b_Home.vue?vue&type=template&id=644f65b4&scoped=true&"
import script from "./b_Home.vue?vue&type=script&lang=js&"
export * from "./b_Home.vue?vue&type=script&lang=js&"
import style0 from "./b_Home.vue?vue&type=style&index=0&id=644f65b4&prod&lang=css&"
import style1 from "@assets/css/dashboard_page.css?vue&type=style&index=1&id=644f65b4&prod&scoped=true&lang=css&"
import style2 from "./b_Home.vue?vue&type=style&index=2&id=644f65b4&prod&scoped=true&lang=css&"
import style3 from "./b_Home.vue?vue&type=style&index=3&id=644f65b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f65b4",
  null
  
)

export default component.exports